import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment.prod';
import { ChatResponse } from '../../models/ChatResponse';
import { AgentInformationModel } from '../../models/agentinformationmodel';

export interface Message {
  role: 'user' | 'assistant';
  content: string;
  timestamp: Date;
}

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  /* ===================================================== */
  /* Configuration */
  /* ===================================================== */
  baseUrl = environment.baseUrl;

  /* ===================================================== */
  /* ✅ GLOBAL CHAT STATE (Persistent Widget) */
  /* ===================================================== */
  private lastResponseId = null;
  messages: Message[] = [
    {
      role: 'assistant',
      content: 'Loading...',
      timestamp: new Date()
    }
  ];

  constructor(private http: HttpClient) { }

  /* ===================================================== */
  /* Send Message to AI */
  /* ===================================================== */
  sendMessage(): Observable<Message> {
    const lastMessage = this.messages
      .filter(m => m.role === 'user')
      .slice(-1)[0];


    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const payload = {
      UserInputText: lastMessage.content,
      PreviousResponseId: this.lastResponseId
    };

    return this.http.post<ChatResponse>(this.baseUrl + "Chat/ChatResponse", payload, { headers }).pipe(
      map(response => {
        console.log('RAW RESPONSE:', response);
        this.lastResponseId = response?.responseId;

        const content = response?.text ?? 'No response';

        return {
          role: 'assistant',
          content,
          timestamp: new Date()
        } as Message;
      }),
      catchError(error => {
        console.error('AI Service Error:', error?.error ?? error);

        return of({
          role: 'assistant',
          content:
            error?.error?.error?.message ??
            'Sorry, an unexpected error occurred.',
          timestamp: new Date()
        } as Message);
      })
    );

  }
 
  getAgentInformation(): Observable<AgentInformationModel> {
    return this.http.get<AgentInformationModel>(this.baseUrl + "Chat/GetAgentInformation");
  }
}
